import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IDeviceCoordinates } from '@/api/routes/devices/types';

import { fetchDevicesGps } from './actionCreators';

interface InitialState {
  devicesCoordinates: IDeviceCoordinates,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  devicesCoordinates: {},
  isLoading: false,
  error: '',
};

export const devicesMapGpsSlice = createSlice({
  name: 'devicesMapGps',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchDevicesGps.fulfilled.type]: (state, action: PayloadAction<IDeviceCoordinates>) => {
      state.isLoading = false;
      state.error = '';
      state.devicesCoordinates = action.payload;
    },
    [fetchDevicesGps.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchDevicesGps.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default devicesMapGpsSlice.reducer;
